import React from "react";
import GalleryLanding from "../../components/gallery/galleryLanding";
import HelmetWrapper from "../../HelmetWrapper";

const Gallery = () => {
  return (
    <HelmetWrapper title="WTF: Gallery">
      <GalleryLanding />
    </HelmetWrapper>
  );
};

export default Gallery;
